/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Cta_HeadlineInputs */

const en_landing_cta_headline = /** @type {(inputs: Landing_Cta_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready to ship your SaaS?`)
};

const zh_landing_cta_headline = /** @type {(inputs: Landing_Cta_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`准备好构建你的 SaaS 了吗？`)
};

/**
* | output |
* | --- |
* | "Ready to ship your SaaS?" |
*
* @param {Landing_Cta_HeadlineInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_cta_headline = /** @type {((inputs?: Landing_Cta_HeadlineInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Cta_HeadlineInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_cta_headline(inputs)
	return zh_landing_cta_headline(inputs)
});
export { landing_cta_headline as "landing.cta.headline" }